import { IconButton, makeStyles, TableCell, TableRow, Tooltip, Typography } from "@material-ui/core";
import React from "react";
import { useIntl } from "react-intl";
import { SwissGermanLocale, SwissTimeZone } from "../../../data/constants";
import { CandidateModuleState, CandidateModuleStateTranslationKey } from "../../../model/examSessionCandidate/CandidateModuleState";
import { CandidateMyModuleViewModel } from "../../../model/me/CandidateMyModuleViewModel";
import { GetTranslatedValueIntl } from "../../../model/Shared/TranslatedValue";
import { TranslationKey } from "../../../translations/TranslationKey";
import TranslatedMessage from "../../translations/TranslatedMessage";
import CancelIcon from "@material-ui/icons/Cancel";

type MyExamsTableModuleRowProps = {
  module: CandidateMyModuleViewModel;
  onCancel: (module: CandidateMyModuleViewModel) => void;
};

const useStyles = makeStyles((theme) => ({
  moduleRow: {
    backgroundColor: theme.palette.action.hover,
  },
  freeCancellationDate: {
    fontStyle: "italic",
    marginLeft: theme.spacing(3),
  },
  cancelButton: {
    padding: 0,
  },
  actions: {
    textAlign: "center",
    padding: theme.spacing(2),
  }

}));

const MyExamsTableModuleRow = ({ module, onCancel }: MyExamsTableModuleRowProps) => {
  const intl = useIntl();
  const classes = useStyles();
  const isFreeCancellationPossible = new Date(module.freeCancellationEndDate) > new Date();

  return (
    <React.Fragment>
      <TableRow className={classes.moduleRow}>
        <TableCell colSpan={7}>
          <b>{GetTranslatedValueIntl(intl, module.name)}</b>
          <Typography variant="subtitle2" component="span" className={classes.freeCancellationDate}>
            {"("}
            <TranslatedMessage id="startCertification.paymentAndCompletionStep.freeCancelDate" />
            {new Date(module.freeCancellationEndDate).toLocaleDateString(SwissGermanLocale, { timeZone: SwissTimeZone })}
            {")"}
          </Typography>
        </TableCell>
        <TableCell>
          {CandidateModuleStateTranslationKey[module.state] && (
            <TranslatedMessage id={CandidateModuleStateTranslationKey[module.state] as TranslationKey} />
          )}
        </TableCell>
        <TableCell>{module.averageGrade}</TableCell>
        <TableCell className={classes.actions}>
          {
            isFreeCancellationPossible && module.state === CandidateModuleState.ApplicationAccepted &&  (
              <Tooltip title={<TranslatedMessage id="selfcancellation.header" />}>
                <IconButton color="primary" className={classes.cancelButton} onClick={()=>onCancel(module)}>
                  <CancelIcon />
                </IconButton>
              </Tooltip>
            )
          }
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
};

export default MyExamsTableModuleRow;
